import { all, call, fork, put, takeLeading } from 'redux-saga/effects'
import * as types from 'store/types'
import * as apis from 'store/apis'
import { setTeams_action } from 'store/actions'

function* getTeams_saga() {
  try {
    const result = yield call(apis.getmyTeams_api)
    yield put(setTeams_action(result))
  } catch (error) {}
}

export function* watchSagas() {
  yield takeLeading(types.GET_TEAMS, getTeams_saga)
}

export default function* teamSaga() {
  yield all([fork(watchSagas)])
}
